import { getString } from "../../common/common";

export const CLICK_HERE = "CLICK_HERE";

export const translations = {
  en: {
    [CLICK_HERE]: "click here",
  },
  kn: {
    [CLICK_HERE]: "ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ",
  },
};

export const tAboutUsCommon = (key = "") => {
  return getString(key, translations);
};
